(() => {
 const locales = window.JINYU_LOCALES;
 const supported=['en','zh-Hans','zh-Hant'];
 const normalize=value=>/zh-(TW|Hant)/i.test(value)?'zh-Hant':/zh/i.test(value)?'zh-Hans':'en';
 let language=normalize(document.documentElement.lang);
 try{const saved=localStorage.getItem('jinyu-home-preview-language');if(supported.includes(saved))language=saved;}catch{}
 const localeCode=()=>language==='zh-Hant'?'zh-TW':language==='zh-Hans'?'zh-CN':'en';
 const t=key=>key.split('.').reduce((value,part)=>value?.[part],locales[localeCode()])??'';
 window.JinyuLanguage={t,get current(){return language;},set(value){if(supported.includes(value)){language=value;try{localStorage.setItem('jinyu-home-preview-language',language);}catch{}apply();}}};
 function apply(){
  const root=document.querySelector('.jinyu-scope');if(!root)return;
  document.documentElement.lang=language;
  root.querySelectorAll('[data-i18n]').forEach(element=>{element.textContent=t(element.dataset.i18n);});
  const title=document.querySelector('title[data-i18n]');if(title)title.textContent=t(title.dataset.i18n);
  for(const attr of ['alt','aria-label','data-category-alt','placeholder']){
   const keyAttr='data-i18n-'+attr;
   root.querySelectorAll('['+keyAttr+']').forEach(element=>element.setAttribute(attr,t(element.getAttribute(keyAttr))));
  }
  root.querySelectorAll('[data-copy-key]').forEach(element=>{
   const suffix=language==='en'?'en':language==='zh-Hant'?'tw':'cn';
   const value=element.getAttribute('data-copy-'+suffix);
   element.textContent=value?.trim()?value:t(element.dataset.copyKey);
  });
  root.querySelectorAll('[data-i18n-image-alt]').forEach(wrapper=>wrapper.querySelectorAll('img').forEach(img=>{img.alt=t(wrapper.dataset.i18nImageAlt);}));
  root.querySelectorAll('[data-copy-image-alt]').forEach(wrapper=>{const label=wrapper.querySelector('h3')?.textContent.trim();if(label)wrapper.querySelectorAll('img').forEach(img=>{img.alt=label;});});
  root.querySelectorAll('#site-language,.sample-language').forEach(select=>{select.value=language;});
  window.dispatchEvent(new Event('jinyu:language'));
  window.dispatchEvent(new Event('resize'));
 }
 document.addEventListener('change',event=>{if(!event.target.matches('#site-language,.sample-language')||!supported.includes(event.target.value))return;language=event.target.value;try{localStorage.setItem('jinyu-home-preview-language',language);}catch{}apply();});
 document.addEventListener('DOMContentLoaded',apply);
 document.addEventListener('shopify:section:load',apply);
})();

